import { render, staticRenderFns } from "./SettingsMacroses.vue?vue&type=template&id=472ffe5e"
import script from "./SettingsMacroses.vue?vue&type=script&lang=js"
export * from "./SettingsMacroses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports